export const PAYMENT_SUCCESS_STATUSES = new Set([
  'SUCCESS',
  'PAYMENT_SUCCESS',
  'PAYMENT_SUCCESSFUL',
  'PAID',
  'CAPTURED',
  'COMPLETED',
]);

export const PAYMENT_FAILURE_STATUSES = new Set([
  'FAILED',
  'FAILURE',
  'PAYMENT_FAILED',
  'CANCELLED',
  'CANCELED',
  'EXPIRED',
  'TIMEOUT',
  'TIMED_OUT',
]);

export const normalizePaymentStatus = (status: string): string => {
  return status.trim().toUpperCase().replace(/[\s-]+/g, '_');
};
